import { render } from "./NestedMethodDisplay.vue?vue&type=template&id=34670111&lang=pug"
import script from "./NestedMethodDisplay.vue?vue&type=script&lang=js"
export * from "./NestedMethodDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__